import { startTransition, useState } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { CopyIDMenuItem } from '#components/patterns/menus/meatball-menu/CopyIDMenuItem.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { DeleteRoleDialog } from '../../../delete/DeleteRoleDialog.tsx';

type Props = {
  value: string;
};

export function RoleActionMenu({ value }: Props) {
  const location = useAppLocation();
  const [roleBeingDeletedId, setRoleBeingDeletedId] = useState<string | null>(null);

  return (
    <>
      <MeatballMenu>
        <CopyIDMenuItem id={value} />
        <MenuItem render={<Link to={`/roles/${value}`} state={{ from: location }} />}>Edit</MenuItem>
        <MenuItem
          render={<Link to={`/roles/add?duplicateFrom=${encodeURIComponent(value)}`} state={{ from: location }} />}
        >
          Duplicate
        </MenuItem>
        <MenuItem onClick={() => startTransition(() => setRoleBeingDeletedId(value))}>Delete</MenuItem>
      </MeatballMenu>
      {roleBeingDeletedId ?
        <DeleteRoleDialog
          roleID={roleBeingDeletedId}
          onCancel={() => {
            setRoleBeingDeletedId(null);
          }}
          onDelete={() => {
            setRoleBeingDeletedId(null);
          }}
        />
      : null}
    </>
  );
}
